<template>
  <div class="products-input-base" :style="styles">
    <h1><img class="head-img" src="/static/img/recommend/lp/kurenotori/products/head_fortune0002.png" alt=""></h1>
    <div class="result-base">
      <h2>あの人の気持ちと二人の未来</h2>
      <p>お相手からあなたに投げられた「言葉」を、下のフォームに入力してください。</p>
      <span class="notice">※最大500字/500字を超える文字は鑑定対象から除外されます</span>
      <textarea ref="textarea" :placeholder="placeholder" v-model="textareaValue" :data-word-count="wordCount"></textarea>

      <form method="post" :action="targetAction" ref="tgtform">
        <input type="hidden" name="number" :value="wordCount">
        <input type="hidden" name="_token" :value="csrfToken">
      </form>
      <span class="btn btn-submit" :class="{disabled: wordCount === 0}" @click="onSubmitClick">占う</span>
    </div>
  </div>
</template>

<script>
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import {INPUT_PARAMS} from '@/utvStore/components/Products/inputParams'
import moment from 'moment';
import * as type from '@/utvStore/store/mutation-types'

export default {
  name: 'ProductsInput03',
  props: {
    requireProf: {
      type: Array,
      default: null,
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data(){
    return {
      lock: false,
      textareaValue: '',
    }
  },
  computed: {
    placeholder(){
      return 'どんな言葉が気になりましたか？'
    },
    wordCount(){
      const NG_DIGIT = '' //いったんNG文字はない。あればここに入れる
      const res = this.textareaValue
        .replace(/\s+/g, '')
        .split('').filter(digit => NG_DIGIT.indexOf(digit) < 0)
        .join('')
        .substring(0,500)

      this.textareaValue = res
      return res.length
    },
    targetAction(){
      return '/products/86/0003/result'
    },
    counselorInfos(){
      return BASIC_DATA.kurenotori
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
  },
  methods: {
    onSubmitClick(){
      if(!this.lock){
        this.lock = true
        this.$refs.tgtform.submit()
      }
    }
  },
}</script>

<style scoped lang='scss'>
@import "../../../../../../sass/commons/commonVariables.scss";

$tori_navy:#142254;
$uranaitv_black:#32373f;

/deep/ {
  img {
    max-width: 100%;
    display: block;
  }
  p {
    margin: 0 auto 24px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}

.products-input-base {
  background: url(/static/img/recommend/lp/kurenotori/bg_baikashineki3.png) repeat-y;
  background-size: 100% auto;
  padding-top: 40px;
  padding-bottom: 60px;
  h1 {
    margin: 0 auto 24px;
  }
  .result-base {
    background: white;
    width: calc(100% - 36px);
    margin: 0 auto 24px;
    padding: 15px;
    padding-bottom: 24px;
    border: 1px solid $tori_navy;
    border-radius: 10px;
    margin-bottom: 8px;
    h1 {
      margin: 0;
      padding-top: 40px;
    }
    h2{
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color: $tori_navy;
      margin: 16px 0 24px;
      .pre-word {
        display: block;
        font-size: 0.8em;
      }
    }
    h4{
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 16px;
      color: $tori_navy;
      margin: 0;
      margin-bottom: 8px;
    }
    p{
      margin: 0;
      color: $uranaitv_black;
      font-size: 14px;
    }
    textarea{
      border-radius: 5px;
      border:1px solid #dadada;
      width: 100%;
      height:295px ;
      padding: 13px;
      margin-bottom: 24px;
      &::placeholder {
        color: #c4c4c4;
        font-size: 14px;
      }
    }
    span {
      display: block;
    }
    

  }
}


.notice{
  font-weight: 300;
  font-size: 12px;
  line-height: 22px;
  color: $uranaitv_black;
  display: block;
  margin-bottom: 16px;

}

.head-str {
  background-color: white;
  position: absolute;
  top: 0;
  left: 15px;
  padding-bottom: 22px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color:$tori_navy;
}
.year-icon{
  position: absolute;
  z-index: 2;
  top: -2px;
  left: 2px;
}

.block-result-item{
  padding-top: 45px;
  position: relative;
  padding-bottom:24px;

  img{
    margin-bottom: 8px;
  }
  
}
.main-image{
  margin-bottom: 24px;
}
.description{
  background-color: #ffffff;
  color: $uranaitv_black;
  padding-top: 0;
  position: relative;
  @include mq('w580') {
  }
}

.head-img {
  width: 144px;
  margin: auto;
}








.regist-birthdate {
  padding: 24px 24px 32px;
  background: var(--mess-bg);
  border-radius: 10px;
  width: 88vw;
  margin: auto;
  margin-bottom: 30px;
  text-align: center;
  color: var(--key-color);
  font-size: 16px;
  @include mq('w580') {
    width: 80%;
  }
  .br-pc {
    display: none;
    @include mq('w580'){
      display: inline;
    }
  }

  .error-title {
    font-weight: bold;
    margin-bottom: 16px;
  }
  .links {
    font-weight: bold;
    margin-bottom: 16px;
  }
  ul {
    margin-bottom: 12px;
    li {
      color: red;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      margin: 0 auto;
      padding-left: 20vw;
      @include mq('w580') {
        width: 50%;
        padding: 0;
      }
    }
  }
  a {
    color: #547fe4;
    text-decoration: none;
    border-bottom: 1px solid red;
    padding-bottom: 3px;
    font-weight: bold;
  }

}

.btn-submit{
  background: linear-gradient(270deg, #5beae8 0%, #537fe4 100%);
  border-radius: 35px;
  border: none;
  padding: 14px 0;
  width: 80%;
  margin: auto;
  display: block;
  line-height: 1;
  font-size: 16px;
  height: auto;
  font-weight: 600;
  &.disabled {
    background: #dcdfe2;
    pointer-events: none;
  }
}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/kurenotori/fortunes/ProductsInput03.vue